import { sendAdvancedNotifications } from '../../../helpers/push-notification/sendAdvancedNotifications';
import { setLoaderStart, setLoaderComplete } from '../../../actions/loader/loader';
import { reset } from 'redux-form';

async function submit(values, { targetingMode, filters, selectedUsers }, dispatch) {
    try {
        dispatch(setLoaderStart('sendNotification'));

        const content = {
            title: values.title,
            message: values.message,
            notificationType: 'admin_broadcast'
        };

        const targetingData = {
            mode: targetingMode,
            filters: targetingMode === 'filters' ? filters : null,
            userIds: targetingMode === 'specific' ? selectedUsers.map(u => u.id) : null,
            schedule: values.scheduleNotification ? values.scheduleTime : null
        };

        const result = await sendAdvancedNotifications(content, targetingData);
        
        if (result.status === 200) {
            dispatch(reset('AdvancedNotificationsForm'));
            
            // Show success message with details
            const successMessage = `Notification sent successfully! Delivered to ${result.deliveredCount || 'all'} users.`;
            alert(successMessage);
        } else {
            throw new Error(result.errorMessage || 'Failed to send notification');
        }

    } catch (error) {
        console.error('Error sending notification:', error);
        alert('Error sending notification: ' + error.message);
    } finally {
        dispatch(setLoaderComplete('sendNotification'));
    }
}

export default submit;